export default "__VITE_ASSET__BE3ArF2X__"